module.exports = __webpack_public_path__ + "static/station-device-07da30af5c7ad0ff1843b81d83e2eaab.jpg";